import React, { useState } from 'react';
import { Switch } from '@consta/uikit/Switch';
// import { cnMixSpace } from '@consta/uikit/MixSpace';
import { Item, Tabs } from '@ui/tabs';
import { Loader } from '@ui/loader';
import { useStore } from '@lib/state-engine';
import { dateFormatter, DATE_TIME_FORMAT } from '@lib/date-formatting';
// import { ButtonClose } from '@ui/button';
import { WarehouseSleeveBadge, WarehouseStationaryBadge } from '@ui/icons';
import { warehouseModel } from '@entities/warehouse';
import { RemoveWarehouse } from '@features/remove-warehouse';
// import { $detalizationOpened, toggleDetalizationPanel } from '../model';
import { BagsList } from '../bags-list';
import { $selectedWarehouseId, $zoomModeEnabled, toggleZoomMode } from '../model';

import styles from './styles.module.css';

const TABS: Item[] = [
  { label: 'культуры', value: 'cultures' },
  { label: 'настройки', value: 'settings' },
];

export const WarehouseDetalization = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].value);
  // const detalizationOpened = useStore($detalizationOpened);
  const warehouseId = useStore($selectedWarehouseId);
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);
  const isLoadingWarehouse = useStore(warehouseModel.$isLoadingWarehouseInfo);
  const zoomMode = useStore<boolean>($zoomModeEnabled); // TODO: состояние по useStore
  const showWarehouse = warehouseId && selectedWarehouse;

  return (
    <div className={styles.container}>
      {/* <ButtonClose
        className={styles.close}
        onClick={() => toggleDetalizationPanel(!detalizationOpened)}
      /> */}
      {isLoadingWarehouse ? (
        <Loader />
      ) : showWarehouse ? (
        <>
          <div className={styles.header}>
            <h1 className={styles.title}>{selectedWarehouse.name}</h1>
            {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.sleeve && (
              <>
                <WarehouseSleeveBadge />
                <Switch
                  label="Режим Zoom"
                  className={styles.zoom}
                  checked={zoomMode}
                  onChange={(e) => {
                    // setZoomMode(e.checked);
                    toggleZoomMode(e.checked);
                  }}
                />
              </>
            )}
            {selectedWarehouse.type === warehouseModel.WAREHOUSE_TYPES.stationary && (
              <WarehouseStationaryBadge />
            )}
          </div>
          <p className={styles.location}></p>
          <dl className={styles.generalParams}>
            <dt>общий вес:</dt>
            <dd>{selectedWarehouse.totalWeight.toFixed(2)} т</dd>
            <dt>создан:</dt>
            <dd>
              {dateFormatter(selectedWarehouse.createdAt).format(DATE_TIME_FORMAT)}
            </dd>
          </dl>
          <Tabs
            className={styles.tabs}
            active={activeTab}
            items={TABS}
            onChange={(v) => setActiveTab(v)}
          />
          {activeTab === 'cultures' && (
            <>
              <dl className={styles.bagParams}>
                <dt>всего:</dt>
                <dd>
                  {selectedWarehouse.totalBags} ({selectedWarehouse.filledBags}{' '}
                  заполнено)
                </dd>
              </dl>
              <BagsList warehouseType={selectedWarehouse.type} />
            </>
          )}
          {activeTab === 'settings' && (
            <div>
              <RemoveWarehouse id={selectedWarehouse.id} />
            </div>
          )}
        </>
      ) : (
        <p className={styles.noWh}>Пожалуйста, выберите склад</p>
      )}
    </div>
  );
};
